import React, { Component } from "react";
import { connect } from "react-redux";
import GoogleMap from "../maps/GoogleMap";
import { fitBounds } from "google-map-react/utils";
import { throttle, startCase } from "lodash";
import { interpolateYlGnBu } from "d3";
import scrollIntoView from "scroll-into-view-if-needed";
import api from "../../store/api/api";
import {
  updateOrCreateSite,
  pullSiteNoteCategories,
} from "../../store/api/calls";

import * as Scroll from "react-scroll";
import * as formFields from "../../utils/forms/formFields";

import moment from "moment";
import TimePicker from "rc-time-picker";
import "rc-time-picker/assets/index.css";

import DatePicker from "react-datepicker";

//components
import SimpleMarker from "../maps/markers/SimpleMarker";
import NoDataListItem from "../maps/listItems/NoDataListItem";
import FloatHeader from "../theme/headers/FloatHeader";
import InfoTile from "../theme/modals/InfoTile";
import Input from "../theme/forms/Input";
import CreateSiteListItem from "../maps/listItems/CreateSiteListItem";
import BaseForm from "../theme/forms/BaseForm";
import { Redirect } from "react-router";
import SimpleListItem from "../maps/listItems/SimpleListItem";

const generateId = (id) => `list-component-${id}`;

export const defaultMapState = {
  //mapstuff
  focusedMarker: 0,
  center: {
    lat: 39.8333333,
    lng: -98.585522,
  },
  zoom: 4,
  activeStep: 1,
  loading: false,
  searchError: false,
  searchText: "",
  siteLookupResults: [],
  selectedSite: {},
  siteCreateData: {},
  createdNotes: [],
};

class SiteCreate extends Component {
  constructor(props) {
    super(props);

    this.defaultMarkerColor = ["#a6cee3", "#1f78b4"];

    const { cookies } = props;
    this.state = defaultMapState;

    this.resetBoundsOnCall = true;
    this.searchDebounce = null;
    //allows us to alter schedule without altering state. We dump it in on submit
    this.schedule = {};
  }

  // needed to set bounds
  getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    const FIXED_SIDEBAR_WIDTH = 350;
    return {
      width: width - FIXED_SIDEBAR_WIDTH,
      height,
    };
  }

  componentDidMount() {
    pullSiteNoteCategories();
  }

  setBounds() {
    //handle case of length 1
    if (this.state.siteLookupResults.length === 1) {
      const center = {
        lat: this.state.siteLookupResults[0].geometry.location.lat,
        lng: this.state.siteLookupResults[0].geometry.location.lng,
      };
      const zoom = 12;
      this.setState({ center, zoom });
      return;
    }

    let lats = this.state.siteLookupResults.map((d) => d.geometry.location.lat);
    let lngs = this.state.siteLookupResults.map((d) => d.geometry.location.lng);
    let bounds = {
      ne: { lat: Math.max(...lats), lng: Math.max(...lngs) },
      sw: { lat: Math.min(...lats), lng: Math.min(...lngs) },
    };

    const { center, zoom } = fitBounds(bounds, this.getWindowDimensions());
    this.setState({ center, zoom });
  }

  _getListObjectandMapMarker = (type) => {
    let listObject, mapMarker;

    switch (type) {
      case "search_result_site":
      default:
        listObject = "SiteCreationListItem";
        mapMarker = "SimpleMarker";
        break;
    }

    return { listObject, mapMarker };
  };

  _randomString() {
    return [...Array(10)]
      .map(() => (~~(Math.random() * 36)).toString(36))
      .join("");
  }

  searchForSites(val) {
    if (val.length < 3) return;

    this.setState({ loading: true, searchError: false });
    return api
      .get("/geocode", { address: val })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.results) {
          this.setState({
            siteLookupResults: res.data.results.map((d) => ({
              ...d,
              id: d.place_id,
            })),
          });
        }
        this.setBounds();
      })
      .catch(() => this.setState({ searchError: true }));
  }

  _handleSearchInput = (val) => {
    this.setState({ searchText: val });
    clearTimeout(this.searchDebounce);
    this.searchDebounce = setTimeout(() => this.searchForSites(val), 600);
  };

  //handles frequent case of their being more points than colors
  _getMarkerColor(d, idx, arr) {
    //remember that data.type is set by the server

    if (d.type === "canvasser") {
      const availCount = this.markerColorArray.length;
      if (idx >= availCount) idx = idx % availCount;
      return this.markerColorArray[idx];
    } else if (d.type === "canvasser_event") {
      const events = {
        log_in: "green",
        log_out: "red",
        check_in: "blue",
        check_out: "orange",
        log_response: "pink",
        create_site: "brown",
      };

      return events[d.event_type];
    } else if (d.type === "canvasser_log") {
      let len = arr.length;
      return interpolateYlGnBu(idx / len);
    }
  }

  _focusedMarkers = () => {
    return this.props.mapLayers
      .filter(
        (d) =>
          d.cluster_id === this.state.sideBarClusterFocused ||
          d.metaData.type === "campaign"
      )
      .filter((d) => d.visible);
  };

  _handleMarkerMouseOver(elem_data) {
    this.setState({ focusedMarker: elem_data.id });
    this._scrollToSideBarElement(elem_data);
  }

  _handleMarkerMouseOut(elem_data) {
    this.setState({ focusedMarker: 0 });
  }

  _renderMarkers() {
    let MapMarker = SimpleMarker;

    let _markerPoints = this.state.siteLookupResults.map((d, i) => {
      let visible = true;
      let focused = false;
      let { lat, lng } = d.geometry.location;
      return (
        <MapMarker
          key={d.id}
          visible={visible}
          focused={this.state.focusedMarker === d.id || focused}
          color={
            this.state.focusedMarker === d.id || focused ? "red" : "#9b4dca"
          } // TODO: CHANGE COLOR SCHEME, COME UP WITH SOMETHING INTELLIGENT HERE.
          lat={lat}
          lng={lng}
          onMouseEnter={() => {
            console.log(d.id, d.layer_id);
            this._setFocusedMarker(d.id, { center: false });
          }}
          onMouseLeave={() => {
            this._setFocusedMarker(0, { center: false });
          }}
        />
      );
    });

    return _markerPoints;
  }

  _handleSiteSelection = (site) => {
    const { place_id } = site;

    api
      .get("/get-google-place", { place_id })
      .then((res) => {
        console.log("Place retreived", res.data);
        this.setState({
          selectedSite: res.data,
          activeStep: 2,
          siteLookupResults: this.state.siteLookupResults.filter(
            (d) => d.id === site.id
          ),
          center: {
            lat: site.geometry.location.lat,
            lng: site.geometry.location.lng,
          },
          zoom:
            this.state.zoom < 9
              ? 14
              : this.state.zoom < 17
              ? this.state.zoom + 2
              : this.state.zoom,
          siteCreateData: {
            ...this.state.siteCreateData,
            lat: site.geometry.location.lat,
            lon: site.geometry.location.lng,
            googleplace: res.data.id,
          },
        });
      })
      .catch((res) => {
        this.setState({
          searchError: "We failed to retreive the site.",
        });
      });
  };

  _renderSideBarDisplay() {
    let data = this.state.siteLookupResults;
    return (
      <div>
        <div className="side-menu-title">
          <div className="form-steps" style={styles.stepCounter}>
            <div
              className="step-counter"
              style={{
                ...styles.stepCounterDot,
                ...(this.state.activeStep === 1 ? styles.activeDot : {}),
              }}
              onClick={() => {
                this.setState({ activeStep: 1, selectedSite: {} }, () =>
                  this._handleSearchInput(this.state.searchText)
                );
              }}
            />
            <div
              className="step-counter"
              style={{
                ...styles.stepCounterDot,
                ...(this.state.activeStep === 2 ? styles.activeDot : {}),
              }}
              onClick={() => {
                if (this.state.activeStep >= 2)
                  this.setState({ activeStep: 2 });
              }}
            />
            <div
              className="step-counter"
              style={{
                ...styles.stepCounterDot,
                ...(this.state.activeStep === 3 ? styles.activeDot : {}),
              }}
              onClick={() => {
                if (this.state.activeStep >= 3)
                  this.setState({ activeStep: 3 });
              }}
            />
          </div>
        </div>
        <div className="side-menu-title">
          <h2 style={styles.title}>Create a site</h2>
          {this.state.activeStep === 1 && (
            <Input
              value={this.state.searchText}
              onChange={this._handleSearchInput}
              placeholder="Search for an address, store, or place"
              style={styles.searchBox}
            />
          )}
        </div>
        <div className="side-menu-body">
          {this.state.activeStep === 1 && this._renderSideBarDataList()}
          {this.state.activeStep === 2 && this._renderSiteCreationFormStep2()}
          {this.state.activeStep === 3 && this._renderSiteCreationFormStep3()}
          {this.state.activeStep === 4 && this._renderSiteCreationFormStep4()}
          {this.state.activeStep === 5 && this._renderOptionsStep5()}
        </div>
      </div>
    );
  }

  _renderSideBarDataList() {
    let ListComponent = CreateSiteListItem;
    let data = this.state.siteLookupResults;
    if (!data || !data.length) {
      return (
        <NoDataListItem
          text={
            this.state.searchText.length > 2
              ? "No data to display."
              : 'Try searches like "Tacos, Austin", "Library, Phoenix", or "10555 E 45th Ave, Denver"'
          }
        />
      );
    }

    let listItems = data.map((d) => {
      return (
        <ListComponent
          id={generateId(d.id)}
          focused={this.state.focusedMarker === d.id}
          onMouseEnter={() =>
            this._setFocusedMarker(d.id, { disableScroll: true })
          }
          onMouseLeave={() =>
            this._setFocusedMarker(0, { disableScroll: true })
          }
          onTitleClick={() => this._handleSiteSelection(d)}
          data={d}
          key={d.id}
        />
      );
    });

    return listItems;
  }

  _renderSiteCreationFormStep2() {
    const formInputs = [
      {
        type: "select",
        title: "Site Type",
        options: [
          { value: null, display: "Permanent" },
          { value: "ad_hoc", display: "One Day Only" },
        ],
      },
      formFields.genericName,
      formFields.genericDescription,
      formFields.addressLine1,
      formFields.addressLine2,
      formFields.city,
      formFields.state,
      { ...formFields.zipcode, dataKey: "zip5" },
    ];

    if (Object.keys(this.state.selectedSite)) {
      let { selectedSite: s } = this.state;
      formInputs.forEach((d) => {
        switch (d.dataKey) {
          case "name":
            d.value = s.name;
            break;
          case "addressline1":
            d.value = s.street_number + " " + s.street_name;
            break;
          case "city":
            d.value = s.city;
            break;
          case "statecode":
            d.value = s.state;
            break;
          case "zip5":
            d.value = s.zip5;
            break;
        }
      });
    }

    return (
      <BaseForm
        inputs={formInputs}
        onSubmit={this._handleFormStep2Submit}
        submitButtonText="Next"
        onCancel={() => this.setState({ activeStep: 1 })}
      />
    );
  }

  _handleFormStep2Submit = (data) => {
    console.log("handle submit", data);
    this.setState({
      siteCreateData: { ...this.state.siteCreateData, ...data },
      activeStep: 3,
    });
  };

  _renderSiteCreationFormStep3 = () => {
    let noteCreateForm = formFields.noteEditCreateForm;
    //set available categories
    noteCreateForm[0].options = this.props.noteCategories.map((d) => ({
      value: d.id,
      display: d.name + (d.assignment_display ? "  (tag)" : ""),
      style: { color: d.color },
    }));

    return (
      <div>
        <BaseForm
          inputs={noteCreateForm}
          onSubmit={this._handleFormStep3Submit}
          submitButtonText="Add Note"
          otherButtons={[
            <div
              className={"button primary-milligram-text button-outline"}
              onClick={() => this.setState({ activeStep: 4 })}
            >
              Next
            </div>,
          ]}
        />
        {this.state.createdNotes.map((d) => (
          <SimpleListItem
            color={d.category.color}
            text={`${d.category.name} ${d.note ? ": " + d.note : ""}`}
          />
        ))}
      </div>
    );
  };

  _handleFormStep3Submit = (data) => {
    const site_id = this.state.siteCreateData.id;

    api
      .post("/notes/", { ...data, category: data.category || "general" })
      .then((res) => {
        let category = this.props.noteCategories.find(
          (d) => d.id === +res.data.category
        ) || {
          name: "General",
        };
        res.data.category = category;
        this.setState({
          createdNotes: [...this.state.createdNotes, { ...res.data }],
        });
      })
      .catch(() => {
        // this._setErrMsg("There was an error. The note was not created.")
      });
  };

  _renderSiteCreationFormStep4 = () => {
    if (this.state.siteCreateData.site_type === "ad_hoc") {
      return <div />;
    } else {
      const weekdays = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      const time_input_format = "HH:mm";
      return (
        <div className="scheduleForm" style={styles.scheduleForm}>
          <h3 className="scheduleFormTitle">Schedule</h3>
          <div className="row" style={{ marginBottom: "5px" }}>
            <div className="column">Day</div>
            <div className="column">Open</div>
            <div className="column">Close</div>
          </div>
          {weekdays.map((d, i) => {
            const open_key = "day" + i + "_open";
            const close_key = "day" + i + "_close";
            const open_val = this.state.selectedSite[open_key]
              ? new moment(this.state.selectedSite[open_key], time_input_format)
              : null;
            const close_val = this.state.selectedSite[close_key]
              ? new moment(
                  this.state.selectedSite[close_key],
                  time_input_format
                )
              : null;
            this.schedule = {
              ...this.schedule,
              [open_key]: open_val ? open_val.format(time_input_format) : null,
              [close_key]: close_val
                ? close_val.format(time_input_format)
                : null,
            };
            return (
              <div className="row">
                <div className="column" style={styles.blueText}>
                  {d.substring(0, 3)}
                </div>
                <div className="column">
                  <TimePicker
                    defaultValue={open_val}
                    showSecond={false}
                    minuteStep={15}
                    onChange={(m) =>
                      m
                        ? (this.schedule[open_key] =
                            m.format(time_input_format))
                        : null
                    }
                  />
                  {/*  value passed in onChange function is a moment object */}
                </div>
                <div className="column">
                  <TimePicker
                    defaultValue={close_val}
                    showSecond={false}
                    minuteStep={15}
                    onChange={(m) =>
                      m
                        ? (this.schedule[close_key] =
                            m.format(time_input_format))
                        : null
                    }
                  />
                </div>
              </div>
            );
          })}

          <div
            className="button"
            style={styles.submitButton}
            onClick={this._handleFormStep4Submit}
          >
            Submit
          </div>
        </div>
      );
    }
  };

  _handleFormStep4Submit = () => {
    // this.setState({siteCreateData:{...this.state.siteCreateData, ...this.schedule}});
    updateOrCreateSite({ ...this.state.siteCreateData, ...this.schedule })
      .then((data) => {
        let site_id = data.id;
        this.state.createdNotes.forEach((d) => {
          api.post("/sitenotes/", { site: site_id, note: d.id });
        });
      })
      .then(() => {
        this.setState({ activeStep: 5 });
      })
      .catch(() => {
        this.state.searchError = "Problem saving the site. It was not saved.";
      });
  };

  _renderOptionsStep5 = () => {
    return (
      <div style={styles.optionsWrapper}>
        <div
          className="button primary"
          style={styles.submitButton}
          onClick={() => {
            this.setState(defaultMapState);
          }}
        >
          Create another site.
        </div>
        <div
          className="button secondary-milligram"
          style={styles.submitButton}
          onClick={() => this.props.history.push("/site")}
        >
          Go back to the sites page.
        </div>
      </div>
    );
  };

  _scrollToSideBarElement(elem) {
    Scroll.scroller.scrollTo("elem-" + elem.id, {
      duration: 300,
      delay: 50,
      smooth: true,
      containerId: "side-menu-scroll-wrapper",
      offset: -100, // Scrolls to element + 50 pixels down the page
    });
  }

  _setFocusedMarker(key, options) {
    if (!options) options = {};
    const { center, noState, disableScroll } = {
      center: true,
      noState: false,
      disableScroll: false,
      ...options,
    };
    //where we are using the db id passed from django as the key
    if (!noState) {
      this.setState({ focusedMarker: key });
    }
    // scroll item in sidebar into view
    if (key && document.getElementById(generateId(key)) && !disableScroll) {
      scrollIntoView(document.getElementById(generateId(key)), {
        behavior: "smooth",
        scrollMode: "if-needed",
      });
    }

    //center the map on the focused element
    let matchingElem = this.state.siteLookupResults.find((d) => d.id === key);
    if (!center || !matchingElem) return;
    let { lat, lng } = matchingElem.geometry.location;
    this.setState({
      center: { lat, lng },
    });
  }

  render() {
    return (
      <div>
        <FloatHeader link="/site" />
        <GoogleMap center={this.state.center} zoom={this.state.zoom}>
          {this._renderMarkers()}
        </GoogleMap>
        <div
          className={`map-side-menu ${this.state.sideBarClosed && "closed"}`}
        >
          <div className="side-menu-wrapper" id="side-menu-scroll-wrapper">
            {this._renderSideBarDisplay()}
          </div>
          <div className={`side-menu-select-wrapper`} style={{ width: "1px" }}>
            {this.state.loading && (
              <div className={`side-menu-option loading`}>
                <i className="fas fa-asterisk" />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export const styles = {
  stepCounter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  stepCounterDot: {
    height: "12px",
    width: "12px",
    borderRadius: "6px",
    backgroundColor: "#aeaeae",
    margin: "0px 10px",
  },
  activeDot: {
    backgroundColor: "#1679c7",
  },
  title: {
    marginBottom: "20px",
  },
  scheduleForm: {
    maxWidth: "380px",
    margin: "25px 30px",
  },
  blueText: {
    color: "#1679c7",
  },
  submitButton: {
    width: "100%",
    margin: "4px auto",
  },
  optionsWrapper: {
    margin: "25px",
  },
};

const mapStateToProps = (state) => ({
  mapLayers: state.trackerMap.mapLayers,
  isLoading: state.trackerMap.isLoading,
  focusedCampaign: state.session.focusedCampaign,
  aggregates: state.aggregates,
  noteCategories: state.siteNotes.categories,
});

export default connect(mapStateToProps)(SiteCreate);
